<template>
  <div
    :class="{
      'flex-1 cursor-pointer': true,
    }"
    @mouseenter="(e) => translateUp(e, -20)"
    @mouseleave="translateDown"
  >
    <div
      ref="cardContent"
      :class="{
        'card-content relative mb-10px flex h-full perspective-1000 transform-preserve-3d': true,
      }"
      @click="runAnimation"
    >
      <div
        ref="cardBack"
        :class="{
          'card-back flex w-full flex-col gap-5 rounded-10px shadow-flip-card backface-hidden': true,
          'text-color-neutral-medium-dark relative top-0 bg-www-color-white p-30px': true,
        }"
      >
        <PortableText
          v-if="content?.flipCardPortableText"
          :portable-data="content?.flipCardPortableText"
        />
      </div>
      <div
        ref="cardFront"
        :class="{
          'card-front absolute top-0 flex min-h-full w-full rounded-10px bg-www-color-neutral-very-light shadow-flip-card backface-hidden hover:bg-www-color-neutral-light': true,
          'flex flex-col items-center justify-center gap-3 p-30px': true,
        }"
      >
        <h5
          :class="{
            'text-center font-ptc-Rajdhani text-xl font-black uppercase text-www-color-accent-blue': true,
          }"
        >
          {{ title }}
        </h5>
        <PtcPicture
          v-if="icon && icon.asset"
          provider="sanity"
          :img-attrs="{ class: 'w-10' }"
          :src="icon.asset._ref"
          :alt="resolvedImage?.altText || ''"
          :quality="75"
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import { gsap } from 'gsap';
import type { FlipCard } from '~/sanity/types';
import { translateDown, translateUp } from '~/components/Molecules/Themes/Animation';

const isToggled = ref(false);
const cardFront = ref<HTMLElement | null>(null);
const cardBack = ref<HTMLElement | null>(null);
const cardContent = ref<HTMLElement | null>(null);
const props = defineProps<FlipCard>();
let tl: gsap.core.Timeline;

const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.icon?.asset?._ref);

onMounted(() => {
  if (!cardFront.value && !cardBack.value && !cardContent.value) {
    throw new Error('Could not find card elements');
  } else {
    gsap.set(cardBack.value, { rotationY: -180 });
    tl = gsap
      .timeline({ paused: true })
      .to(cardFront.value, { duration: 1, rotationY: 180, ease: 'linear' })
      .to(cardBack.value, { duration: 1, rotationY: 0, ease: 'linear' }, 0)
      .to(cardContent.value, { z: 50, y: 0 }, 0)
      .to(cardContent.value, { z: 0, y: 0 }, 0.5);
  }
});
const runAnimation = () => {
  isToggled.value = !isToggled.value;
  if (isToggled.value) {
    tl.play();
  } else {
    tl.reverse();
  }
};
</script>
<style>
.card-back img {
  max-width: 2.5rem;
}
</style>
